import React from 'react'
import { useInView } from 'react-intersection-observer'

interface CategoryLoaderProps {
  children: React.ReactNode
  categoryId: string
  showCategoryDetails: (categoryId: string) => void
  disabled: boolean
}

const CategoryLoader: React.FC<CategoryLoaderProps> = ({
  children,
  categoryId,
  showCategoryDetails,
  disabled,
}) => {
  const { ref, inView } = useInView({
    rootMargin: '-200px 0px 700px 0px',
  })

  React.useEffect(() => {
    if (inView && !disabled) {
      showCategoryDetails(categoryId)
    }
  }, [inView, categoryId, showCategoryDetails, disabled])

  return <div ref={ref}>{children}</div>
}

export default CategoryLoader
